import TwoForOneCampaign from './TwoForOneCampaign'

export default TwoForOneCampaign
